// extracted by mini-css-extract-plugin
module.exports = {"H2":"h2_H2__3RAtq","IconLeft":"h2_IconLeft__cd5lo","IconRight":"h2_IconRight__hA2FF","BorderBottom":"h2_BorderBottom__1sbFJ"};